

import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import {Button, Paper, Typography} from '@mui/material';
import { UserContext } from './UserContext'
import { useEffect, useRef, useState, useContext } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import { ReactComponent as AppleMusicIcon } from '../assets/apple_music.svg';



const AppleMusicContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const AppleMusicLogin = () => {
    const [musicKit, setMusicKit] = useState(null);
    const [loading, setLoading] = useState(false);
    const {user, setUser} = useContext(UserContext);


    useEffect(() => {
      const script = document.createElement('script');
      script.src = "https://js-cdn.music.apple.com/musickit/v3/musickit.js";
      script.async = true;
      document.body.appendChild(script);
    }, []);


    useEffect(() => {
      console.log("adding event listener")
      document.addEventListener('musickitloaded', async function () {
        // Call configure() to configure an instance of MusicKit on the Web.
          try {
            console.log("configuring musickit")
            await window.MusicKit.configure({
              developerToken: process.env.REACT_APP_APPLE_DEVELOPER_TOKEN,
              app: { name: 'Dallpaper', build: 'latest' },
            });
            const music = await window.MusicKit.getInstance()
            setMusicKit(music)
          } 
          catch (err) {
            console.log(err)
          }
        });
    }, []);

    const handleClick = async () => {
      setLoading(true)
      console.log(musicKit)
      await musicKit.authorize()
      if(musicKit.isAuthorized){
        dallpaperAppleMusicLogin(musicKit.musicUserToken)
      }
    }

    const dallpaperAppleMusicLogin = async (userToken) => {
      if (user && !user.signed_into_apple_music){
        const options  =  {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer: ' + user.firebase_token},
          body: JSON.stringify({ apple_token: userToken })
        };
        try {
          const response = await fetch(`${process.env.REACT_APP_DALLPAPER_API_URL}/login/apple`, options)
          const appleLoginResponse = await response.json()
          setLoading(false)
          if (response.ok){
            console.log("Confirmed apple token in database", appleLoginResponse)
            setUser({...user, signed_into_apple_music: true})
          }
          else {
            console.log(">:( Failed to store apple token in database", appleLoginResponse)
          }
        } catch (e) {
          console.log("Could not reach backend", e)
          setLoading(false)
        }
      } else { console.log("no user yet") }
    }
  

    return (
      <AppleMusicContainer>
        <div>Apple Music perhaps?</div>
        <LoadingButton loading={loading} onClick={(event) => handleClick(event)}>
          <AppleMusicIcon style={{width:"30%"}}></AppleMusicIcon>
        </LoadingButton>
      </AppleMusicContainer>
    )
};

export default AppleMusicLogin;